import moment from 'moment'
import React from 'react'
import { i18n } from '../../domain/index'
import css from './monthField.css'

// eslint-disable-next-line import/no-unresolved
import '!style-loader!css-loader!react-day-picker/style.css'

type Props = {
  value: string
  label?: string
  onChange?: (...props: any) => any
}

type State = {
  month: string
  open: boolean
}

class MonthField extends React.Component<Props, State> {
  node: any

  constructor(props: Props) {
    super(props)

    this.state = {
      month: props.value || moment().format('YYYY-MM'),
      open: false,
    }
  }

  UNSAFE_componentWillMount() {
    //TODO: rewrite outdated and unsafe life circle hooks
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // Update state month if value changes in props.
    if (nextProps.value !== this.state.month) {
      this.setState({ month: nextProps.value })
    }
  }

  handleClick = (e: any) => {
    if (this.node.contains(e.target)) {
      return
    }

    this.setState({
      open: false,
    })
  }

  getFieldValue = () => {
    const from = moment(this.state.month).startOf('month')
    const to = moment(this.state.month).endOf('month')
    return `${from.format('MMMM')} (${from.format('D.M.')} - ${to.format('D.M.YYYY')})`
  }

  getSelectedRange = () => {
    const from = moment(this.state.month).startOf('month')
    const to = moment(this.state.month).endOf('month')

    return {
      from: from.toDate(),
      to: to.toDate(),
    }
  }

  onFieldClick = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    const { label } = this.props
    const isLabelShown = !!label || typeof label === 'undefined'

    return (
      <div className={css.component} ref={(node) => (this.node = node)}>
        <div className={css.field} onClick={this.onFieldClick}>
          {isLabelShown && <div className={css.label}>{label || i18n.t('monthField.defaultLabel')}:</div>}
          <div className={css.input}>{this.getFieldValue()}</div>
        </div>
      </div>
    )
  }
}

export default MonthField
